// apps/account-portal/src/pages/ContactPage.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-hot-toast';
import { CONTACT_EMAIL } from '@redpanda/ui';
import PageContainer from '../components/PageContainer';
import PageTitle from '../components/PageTitle';
import Card from '../components/Card';
import PageFooter from '../components/PageFooter';

/**
 * 聯絡我們（公開）：信箱直接寫出來＋右邊「複製」
 * 不放 mailto「寄信」：Windows 11 預設沒有郵件程式，多數人按了沒反應；複製後貼到慣用的信箱最穩
 */
const ContactPage: React.FC = () => {
  const { t } = useTranslation();

  const copyEmail = async () => {
    try {
      await navigator.clipboard.writeText(CONTACT_EMAIL);
      return toast.success(t('pages.contact.copied'));
    } catch {
      // 剪貼簿 API 在視窗沒有焦點、非 HTTPS 時會拒絕：改用舊的 execCommand 複製（主流複製按鈕的備援做法）
    }
    const input = document.createElement('textarea');
    input.value = CONTACT_EMAIL;
    input.style.position = 'fixed';
    input.style.opacity = '0';
    document.body.appendChild(input);
    input.select();
    const ok = document.execCommand('copy');
    input.remove();
    if (ok) toast.success(t('pages.contact.copied'));
    else toast.error(t('pages.contact.copyFailed'));
  };

  return (
    <PageContainer>
      <PageTitle title={t('pages.contact.title')} subtitle={t('pages.contact.subtitle')} />
      <Card className="max-w-xl">
        <p className="text-[13px] text-[var(--text-secondary)]">{t('pages.contact.emailLabel')}</p>
        <div className="mt-1 flex flex-wrap items-center gap-3">
          <span className="text-lg font-semibold text-[var(--text-primary)] break-all select-all">{CONTACT_EMAIL}</span>
          <button
            type="button"
            onClick={copyEmail}
            className="inline-flex h-8 items-center justify-center rounded-md border border-[var(--border-c)] px-3 text-sm font-medium text-[var(--text-primary)] hover:bg-[var(--page-bg)]"
          >
            {t('pages.contact.copy')}
          </button>
        </div>
        <ul className="mt-6 space-y-1 text-sm text-[var(--text-secondary)]">
          <li>
            {t('pages.contact.boardPrefix')}
            <Link to="/board" className="text-[var(--accent)] hover:underline">{t('pages.contact.boardLink')}</Link>
            {t('pages.contact.boardSuffix')}
          </li>
        </ul>
      </Card>
      <PageFooter />
    </PageContainer>
  );
};

export default ContactPage;
